import React, { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useUsersContext } from "../Context/UsersContext";

export default function Login() {
  const { loggedData } = useUsersContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const auth = getAuth();

  const handleLogin = async (e) => {
    e.preventDefault(); // Previene el comportamiento por defecto del formulario
    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;
      console.log("Usuario autenticado:", user);
      window.location.replace("/adm");
      // Puedes redirigir al usuario a otra página, por ejemplo:
      // navigate('/home');
    } catch (err) {
      setError(err.message);
      console.error("Datos incorrectos");
    }
  };


  return (
    <div className="loaderCont gap1rem">
      <img
        className="navbar-sidebar-logo"
        src="https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/logo1986_square.png?alt=media&token=dde69511-bd57-4924-9174-44859fa5a516"
        alt=""
      />
      <h2>Iniciar Sesión</h2>
      <form className="loginformcont" onSubmit={handleLogin}>
        {" "}
        {/* Corregido el manejo del onSubmit */}
        <div className="inputWlabel">
          <label className="inputwlabel-label">Email</label>
          <input
            className="inputwlabel-input"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="inputWlabel">
          <label className="inputwlabel-label">Contraseña</label>
          <input
            className="inputwlabel-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button className="buttonbyn" type="submit">
          Iniciar Sesión
        </button>
      </form>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}
